module.exports = "<div class=\"form-group\">    \n    <select class=\"form-control\" required id=\"field\" required [(ngModel)] = \"fieldSelect\" (change)=\"onSelected(fieldSelect)\" >\n      <option *ngFor=\"let field of fields\" [ngValue]=\"field.valor\" >{{field.descripcion}}</option>\n    </select>\n  </div>"


//////////////////
// WEBPACK FOOTER
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/tipo-unidad-cobro/tipo-unidad-cobro.component.html
// module id = ../../../../../src/app/components/tipo-unidad-cobro/tipo-unidad-cobro.component.html
// module chunks = main